// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0aa89f57","976":"47c844bb"}[chunkId] + ".chunk.js";
};